import React from 'react';
import '../Privacy/PrivacyPolicy.css'; 
import { config } from '../../config/config';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import BackButton from '../../components/BackButton';

const Refundpolicy = ({ onBack }) => {
  const navigate = useNavigate();
  
  const handleBackClick = () => {
    // Navigate back to the previous page or redirect to home
    navigate('/Dashboard'); // -1 takes the user back to the previous page in history
    // Or use navigate('/') to redirect to the home page or any default page
    // navigate('/'); // This would navigate to the home page
  };

  React.useEffect(() => {
    document.documentElement.style.setProperty('--main-color', config.color);
  }, [config.color]);

  return (
    <>
    <Header/>
    <div className="privacy-policy-container">
      <div className='privacy_policy_page'> 
     <div className="privacytopdiv">
        <BackButton onClick={() => navigate('/Dashboard')} title="Refund Policy" />
      </div>

      <div id="policy-content">
        <div>{config.refundTitle}</div>
        <p>Last Updated: {config.refundEffectiveDate}</p>

        {config.refundPoints.map((section, index) => (
          <div key={index}>
            <div>{section.heading}</div>
            {section.subsections ? (
              section.subsections.map((sub, subIndex) => (
                <div key={subIndex}>
                  <div>{sub.heading}</div>
                  {sub.content.map((text, textIndex) => (
                    <p key={textIndex}>{text}</p>
                  ))}
                </div>
              ))
            ) : (
              <div>
                {section.content.map((text, textIndex) => (
                  <p key={textIndex}>{text}</p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
    </div>
    <Footer/>
    </>
  );
};

export default Refundpolicy;
